<template>
    <div>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
        >
            <template slot-scope="scope" slot="menu">
                <el-button icon="el-icon-tickets" size="small" type="text"
                           @click.stop="handleOrder(scope.row)">预约信息 (<span style="color: red">{{ scope.row.room_order_count }}</span>/<span style="color: #8c939d">{{ scope.row.room_order_all_count }}</span>)
                </el-button>
            </template>
        </avue-crud>

        <el-dialog title="预约信息" :visible.sync="dialogOrderVisible" width="80%" center>
            <RoomOrderMeeting :defaultParams="{room_id : this.roomId }"></RoomOrderMeeting>
        </el-dialog>
    </div>
</template>
<script>
  import curd from './Base/Crud'
  import RoomOrderMeeting from './RoomOrderMeeting'

  export default {
    mixins: [curd],
    components: {RoomOrderMeeting},
    data() {
      return {
        dialogOrderVisible: false,
        url: '/room',
        defaultParams: {type:1},  // 类型：1会议室，2VIP食堂, 3培训场地
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText: '新增场所', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '场所名称',
              overHidden: true,
              prop: 'title',
              span: 24,
              align: 'left',
              rules: [{
                type: 'string', required: true, message: '场所名称不能为空', trigger: 'blur'
              }]
            },
            {
              label: '设施',
              overHidden: true,
              prop: 'facilitie',
              span: 24,
              align: 'left',
              rules: [{
                type: 'string', required: true, message: '设施不能为空', trigger: 'blur'
              }]
            },
            {
              label: '容纳人数',
              overHidden: true,
              prop: 'contain',
              span: 24,
              rules: [{
                type: 'string', required: true, message: '容纳人数不能为空', trigger: 'blur'
              }]
            },
            {
              label: '地址',
              overHidden: true,
              prop: 'address',
              span: 24,
              align: 'left',
              rules: [{
                type: 'string', required: true, message: '地址不能为空', trigger: 'blur'
              }]
            },
            {
              label: '状态',
              prop: 'status',
              addDisplay: false,
              type: 'select',
              dicData: [{'label': '开启', 'value': 0}, {'label': '关闭预约', 'value': 1}],
              span: 24,
              rules: [{
                required: true, message: '状态不能为空', trigger: 'blur'
              }]
            }
          ]
        },
        roomId: null,
      }
    },
    methods: {
      handleOrder(row) {
        this.dialogOrderVisible = true;
        this.roomId = row.id;
      }
    }
  }
</script>
